'use memo';

import { useCallback } from 'react';
import { match } from 'ts-pattern';
import type { IconName } from '@/components/Icon/iconMap';
import { DeviceGenre } from '@/constants/device';
import { defaultNS, useTranslation } from '@/lib/i18n';
export function useDeviceGenre() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'domain.device.genre'
  });
  const icon = useCallback((genre: DeviceGenre): IconName => match(genre).with(DeviceGenre.WORKSTATION, () => 'LaptopIcon' as const).with(DeviceGenre.LAPTOP, () => 'LaptopIcon' as const).with(DeviceGenre.MOBILE, () => 'SmartphoneIcon' as const).with(DeviceGenre.TABLET, () => 'SmartphoneIcon' as const).with(DeviceGenre.MONITOR, () => 'MonitorIcon' as const).with(DeviceGenre.PRINTER, () => 'PrinterIcon' as const).with(DeviceGenre.SERVER, () => 'ServerIcon' as const).with(DeviceGenre.OTHER, () => 'MouseIcon' as const).exhaustive(), []);
  return {
    i18n: t,
    icon
  };
}